import React from 'react';
export function PersonalStory() {
  return <section className="mb-12" data-id="element-260">
      <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-261">
        <div className="md:w-2/5" data-id="element-262">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rjZ5LGQMP7ZgR8RnKPUTpN/oldguys.png" alt="Äldre par som löser pussel tillsammans vid ett träbord" className="w-full h-auto rounded-lg shadow-md object-cover" data-id="element-263" />
          <div className="mt-2 text-xs text-gray-500 italic" data-id="element-264">
            "Innan Brainy kunde jag knappt klara ett enkelt pussel. Nu löser jag
            korsord på rekordtid."
          </div>
        </div>
        <div className="md:w-3/5" data-id="element-265">
          <p className="text-lg mb-4" data-id="element-266">
            <span className="font-semibold text-amber-800" data-id="element-267">
              Det började med små saker som ingen märkte utom jag.
            </span>{' '}
            Jag kunde inte hitta mina nycklar. Jag glömde vad jag skulle köpa i
            mataffären. Jag tappade tråden mitt i en mening.
          </p>
          <p className="mb-4" data-id="element-268">
            Vid 53 års ålder började jag märka att min hjärna inte fungerade som
            förr. Det skrämde mig.{' '}
            <span className="underline" data-id="element-269">
              Jag har alltid varit den som kommer ihåg allt
            </span>{' '}
            — födelsedagar, möten, shoppinglistor. Plötsligt kände jag mig
            förvirrad och osäker.{' '}
            <span className="font-semibold" data-id="element-270">
              Jag började undra om min familj märkte förändringen. Såg de mig
              annorlunda?
            </span>
          </p>
          <p className="mb-4" data-id="element-271">
            Det värsta var när jag glömde min dotters födelsedag. Jag såg
            besvikelsen i hennes ögon.{' '}
            <span className="font-semibold text-red-700" data-id="element-272">
              Den dagen insåg jag att mitt problem inte bara påverkade mig, utan
              också människorna jag älskar.
            </span>{' '}
            Var det början på demens? Skulle det bara bli värre?{' '}
            <span className="italic" data-id="element-273">
              Skulle jag bli en börda för min familj?
            </span>
          </p>
        </div>
      </div>
      <p className="mb-4" data-id="element-274">
        En dag när jag kämpade för att komma ihåg lösenordet till min dator (för
        tredje gången samma vecka), bröt jag ihop i tårar. Min man Magnus såg
        mig och sa: "Älskling, det här är inte du. Vi måste hitta en lösning."
      </p>
      <p className="mb-4" data-id="element-275">
        Jag hade provat allt — anteckningsböcker, påminnelser i telefonen, till
        och med meditation. Inget hjälpte med den mentala dimman som verkade
        omge mig konstant.{' '}
        <span className="font-medium" data-id="element-276">
          Jag kände mig som en skugga av mitt tidigare jag, och det skrämde mig
          att tänka på hur mycket värre det kunde bli.
        </span>
      </p>
      <div className="bg-gray-50 border border-gray-200 p-4 rounded-lg mb-4" data-id="element-277">
        <h3 className="text-base font-semibold text-gray-700 mb-2" data-id="element-278">
          Visste du att?
        </h3>
        <p className="text-sm" data-id="element-279">
          Enligt en studie publicerad i Journal of Neuroscience (2022) börjar
          vår hjärnvolym minska med upp till 0,5% per år efter 40 års ålder.
          Forskare vid Harvard Medical School har visat att denna förlust
          specifikt drabbar hippocampus – hjärnans centrum för minne och
          inlärning.
        </p>
      </div>
      <p className="text-lg font-semibold text-amber-800 mb-4" data-id="element-280">
        Det var då min vän Lena berättade om något som hade förändrat hennes
        liv...
      </p>
    </section>;
}